import React, { useEffect } from 'react'
import DescargaDiariaView from '../../components/listados/controlDiario/DescargaDiariaView'
import { actualizarDatosTablaDescargaDiaria, actualizarDatosTablaDescargaPorExportador } from '../../actions/controlDiario'
import { connect } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_RESUMEN_DESCARGA } from '../../../../config/forms'
import CamposBusqueda from '../../components/listados/CamposBusqueda'
import ReporteDescargaExportadorCereal from '../../components/listados/controlDiario/ReporteDescargaExportadorCereal'
import { parseEntityId } from '../../../../models/entity'

function ControlDescargaDiario (props) {
  const { actualizarDatosTablaDescargaDiaria, actualizarDatosTablaDescargaPorExportador, change: formChange } = props

  useEffect(() => {
    actualizarDatosTablaDescargaDiaria(new Date(), new Date())
    actualizarDatosTablaDescargaPorExportador(new Date(), new Date())
  }, [actualizarDatosTablaDescargaDiaria, actualizarDatosTablaDescargaPorExportador])

  const actualizarFechas = (fechaD, fechaH) => {
    formChange('fechaDesde', fechaD)
    formChange('fechaHasta', fechaH)
  }

  const handleSubmit = () => {
    const { fechaDesde, fechaHasta, exportadorReporte, cerealReporte } = props
    const exportador = parseEntityId(exportadorReporte) || null
    const cereal = (cerealReporte && (cerealReporte.trim() !== 'UNDEF') && cerealReporte.trim()) || null
    actualizarDatosTablaDescargaDiaria(fechaDesde, fechaHasta, exportador, cereal)
    actualizarDatosTablaDescargaPorExportador(fechaDesde, fechaHasta, exportador, cereal)
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <CamposBusqueda actualizarFechas={actualizarFechas} handleSubmit={handleSubmit} />
      <DescargaDiariaView />
      <div style={{ marginTop: '2%' }}>
        <ReporteDescargaExportadorCereal />
      </div>
    </>
  )
}

const selector = formValueSelector(FORM_RESUMEN_DESCARGA)

const mapStateToProps = (state) => ({
  exportadorReporte: selector(state, 'exportador'),
  cerealReporte: selector(state, 'cereal'),
  fechaDesde: selector(state, 'fechaDesde'),
  fechaHasta: selector(state, 'fechaHasta')
})

const mapActionsToProps = {
  actualizarDatosTablaDescargaDiaria,
  actualizarDatosTablaDescargaPorExportador
}

const withReduxForm = reduxForm({
  form: FORM_RESUMEN_DESCARGA
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(ControlDescargaDiario))
